module.exports = __webpack_public_path__ + "img/16x9_blur.a57cf0af.jpg";